import * as tslib_1 from "tslib";
import { TextField, MovieClip } from "@awayjs/scene";
import { DefaultSceneGraphFactory } from "@awayjs/parsers";
import { AS2MovieClipAdapter } from "../adapters/AS2MovieClipAdapter";
import { AS2TextFieldAdapter } from "../adapters/AS2TextFieldAdapter";
var AS2SceneGraphFactory = (function (_super) {
    tslib_1.__extends(AS2SceneGraphFactory, _super);
    function AS2SceneGraphFactory(view) {
        var _this = _super.call(this) || this;
        _this._view = view;
        return _this;
    }
    AS2SceneGraphFactory.prototype.createMovieClip = function (timeline) {
        if (timeline === void 0) { timeline = null; }
        return new AS2MovieClipAdapter(new MovieClip(timeline), this._view).adaptee;
    };
    AS2SceneGraphFactory.prototype.createTextField = function () {
        return new AS2TextFieldAdapter(new TextField(), this._view).adaptee;
    };
    return AS2SceneGraphFactory;
}(DefaultSceneGraphFactory));
export { AS2SceneGraphFactory };



// WEBPACK FOOTER //
// ../dist/lib/factories/AS2SceneGraphFactory.js